import React from 'react';
import { Link } from 'react-router-dom';

export default function LegalLayout({ eyebrow, title, updated, children }) {
  return (
    <div className="min-h-screen" style={{ background: 'var(--brand-bg)' }}>
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <span className="pill">{eyebrow}</span>
        <h1 className="page-title section-gap">{title}</h1>
        {updated && <p className="mt-2 text-xs font-semibold text-slate-400">Last updated: {updated}</p>}
        <div className="mt-8 space-y-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
          {children}
        </div>
        <Link to="/" className="mt-8 inline-block text-sm font-bold text-[var(--brand-primary)] hover:underline">
          ← Back to home
        </Link>
      </div>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section>
      <h2 className="text-base font-black text-slate-900">{title}</h2>
      <div className="mt-2 space-y-3 text-sm leading-relaxed text-slate-600">{children}</div>
    </section>
  );
}
